// import Constants from './Constants';
import moment from "moment";

/* -------------------------------------------- TIME  ----------------------------------------------------------- */

// Convert Text to Time
function convertTextToTime(text) {
  const timeRegex = /^(\d{1,2})(:)?(\d{2})?\s?(AM|PM)?$/i; // Regex to match time format
  const match = text.match(timeRegex);

  if (match) {
    let hours = parseInt(match[1], 10);
    const minutes = match[3] ? parseInt(match[3], 10) : 0;
    const period = match[4] ? match[4].toUpperCase() : "AM";

    if (hours === 12) {
      hours = period === "AM" ? 0 : 12;
    } else if (period === "PM") {
      hours += 12;
    }

    const time = new Date();
    time.setHours(hours, minutes, 0, 0);

    return time;
  }

  return null; // Return null for invalid format
}

// Check the Time Difference and Check Time difference is within 12 hours
function checkTimeDifference(startDateTime, endDateTime, withInHours) {
  const start = new Date(startDateTime);
  const end = new Date(endDateTime);
  let obj = {};

  // Check if dates are valid
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    obj.status = false;
    obj.msg = "* Invalid date format";
    return obj;
  }

  // Check if start time is less than end time
  if (start >= end) {
    obj.status = false;
    obj.msg = "* Start time cannot be less than or equal to end time.";
    return obj;
  }

  // Calculate difference in milliseconds
  const diffInMilliseconds = Math.abs(end - start);

  // Calculate the difference in hours
  const diffInHours = diffInMilliseconds / (1000 * 60 * 60);

  // Check if difference is within 12 hours
  if (diffInHours <= withInHours) {
    obj.status = true;
    obj.totalHours = diffInHours;
    obj.msg = diffInHours + " hours";
    return obj;
    // return <p className='successMsg'>Shifts hours: {diffInHours} hours.</p>;
  } else {
    obj.status = false;
    obj.msg = "* Shifts cannot be longer than " + withInHours + " hours.";
    return obj;
  }
}

// Get only Time in 24 Hours formate
function getTimeFromStringIn24hours(dateString) {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
}

// Get only Time in AM and PM Hours formate
function getTimeFromStringInAmPm(dateString) {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12; // Convert 0 to 12 for AM/PM format

  return `${displayHours}:${minutes} ${period}`;
}

// Show the time in display screen "just now," "1 minute ago," "10 minutes ago," "1 hour ago,"
export const formatTimeDifference = (timestamp) => {
  const now = new Date();
  const timeDiff = now - new Date(timestamp); // Difference in milliseconds

  const seconds = Math.floor(timeDiff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return "just now";
  } else if (minutes < 60) {
    return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  } else if (hours < 24) {
    return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  } else {
    return `${days} day${days !== 1 ? "s" : ""} ago`;
  }
};

export const formatToTwoDigits = (number) => {
  if (isNaN(number)) return "Invalid number";
  return number < 10 ? `0${number}` : `${number}`;
};

/* -------------------------------------------- TIME END ----------------------------------------------------------- */

// Common Validation functions

// Capitalize function
function capitalize(text) {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
}

// Required Fields
export const validateRequired = (value) => {
  return value.trim() !== "";
};

// Email
export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

// Password
export const validatePassword = (password) => {
  // Password must be at least 8 characters long
  return password.length >= 8;
};

// Contact Number
export const validateContactNumber = (contactNumber) => {
  // Example: Validate US phone number (10 digits)
  const re = /^\d{10}$/;
  return re.test(contactNumber);
};

// Contact Number
export const isValidNumber = (value) => {
  return value === "" || /^\d*\.?\d{0,2}$/.test(value);
};

//Get Date & Time   //'default'
export const getCurrentDate = (format = "default") => {
  const currentDate = new Date();
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  switch (format) {
    case "default": {
      const now = moment().tz(userTimezone); // current time in user's timezone
      const formattedDate = now.format(
        process.env.REACT_APP_DATE_FORMATE || "DD-MM-YYYY",
      ); // format from .env
      return formattedDate;
    }

    case "locale": {
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const date = currentDate.toLocaleDateString("en-US", options);

      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };
      const time = currentDate.toLocaleTimeString("en-US", timeOptions);

      return `${date} ${time}`;
    }

    case "iso": {
      return currentDate.toISOString();
    }

    case "short": {
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
      const day = String(currentDate.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    }

    default: {
      throw new Error("Invalid format specified");
    }
  }
};

// NumberFormat Currency - Safe & Proper
export const currencyFormat = (value) => {
  if (value === null || value === undefined || value === "") return "";

  // Convert to number safely
  let num = Number(String(value).replace(/,/g, ""));
  if (isNaN(num)) return "";

  // Keep decimals if present
  const parts = num.toString().split(".");
  let integerPart = parts[0];
  const decimalPart = parts[1] ? `.${parts[1]}` : "";

  // Add comma formatting to integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return integerPart + decimalPart;
};

export const capitalizeFirstWord = (str) => {
  if (!str) return str; // Handle empty or null strings
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// format Date
export const formatDate = (date) => {
  if (!date) {
    return "";
  }

  const now = moment(date);
  if (!now.isValid()) {
    return date;
  }
  const formattedDate = now.format(
    process.env.REACT_APP_DATE_FORMATE || "DD-MM-YYYY",
  );
  return formattedDate;
};

// format Date Time
export const formatDateTime = (date) => {
  if (!date) {
    return "";
  }

  const now = moment(date);
  if (!now.isValid()) {
    return date;
  }
  const formattedDate = now.format(
    process.env.REACT_APP_DATE_FORMATE_WITH_TIME,
  );
  return formattedDate;
};

// Handles:
// 1. DD-MM-YYYY HH:mm:ss
// 2. ISO format (2026-06-22T04:30:53.097Z)
// 3. If 'to' is null/undefined, calculates duration till current time

export const calculateDuration = (from, to) => {
  const parseDate = (dateTime) => {
    if (!dateTime) return null;

    // ISO format
    if (dateTime.includes("T")) {
      const date = new Date(dateTime);
      return isNaN(date.getTime()) ? null : date;
    }

    // DD-MM-YYYY HH:mm:ss
    const [datePart, timePart = "00:00:00"] = dateTime.split(" ");
    const [day, month, year] = datePart.split("-");

    if (!day || !month || !year) return null;

    const date = new Date(`${year}-${month}-${day}T${timePart}`);
    return isNaN(date.getTime()) ? null : date;
  };

  if (!from) return "0 sec";

  const fromDate = parseDate(from);
  const toDate = to ? parseDate(to) : new Date();

  if (!fromDate || !toDate) return "0 sec";

  const diffSeconds = Math.floor((toDate - fromDate) / 1000);

  if (diffSeconds <= 0) return "0 sec";

  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;
  const year = 365 * day;

  const formatValue = (value) =>
    Number.isInteger(value) ? value : Number(value.toFixed(1));

  if (diffSeconds < minute) {
    return `${diffSeconds} ${diffSeconds === 1 ? "sec" : "secs"}`;
  }

  if (diffSeconds < hour) {
    const mins = Math.floor(diffSeconds / minute);
    return `${mins} ${mins === 1 ? "min" : "mins"}`;
  }

  if (diffSeconds < day) {
    const hours = formatValue(diffSeconds / hour);
    return `${hours} ${hours === 1 ? "hour" : "hours"}`;
  }

  if (diffSeconds < month) {
    const days = Math.floor(diffSeconds / day);
    return `${days} ${days === 1 ? "day" : "days"}`;
  }

  if (diffSeconds < year) {
    const months = Math.floor(diffSeconds / month);
    return `${months} ${months === 1 ? "month" : "months"}`;
  }

  const years = Math.floor(diffSeconds / year);
  return `${years} ${years === 1 ? "year" : "years"}`;
};

function addTimeStrings(t1, t2) {
  const toSeconds = (time) => {
    const [hh, mm, ss] = time.split(":").map(Number);
    return hh * 3600 + mm * 60 + ss;
  };

  const toTimeString = (totalSeconds) => {
    const hh = Math.floor(totalSeconds / 3600);
    const mm = Math.floor((totalSeconds % 3600) / 60);
    const ss = totalSeconds % 60;
    return [hh, mm, ss].map((unit) => String(unit).padStart(2, "0")).join(":");
  };

  const totalSeconds = toSeconds(t1) + toSeconds(t2);
  return toTimeString(totalSeconds);
}

export const applyMathAndFormat = (number, mathType = null) => {
  if (number === null || number === undefined || number === "") return "";
  let num = Number(number);
  if (isNaN(num)) return "";
  // 🔹 Apply math operations if provided
  switch (mathType) {
    case "round":
      num = Math.round(num);
      break;
    case "ceil":
      num = Math.ceil(num);
      break;
    case "floor":
      num = Math.floor(num);
      break;
    default:
      break;
  }
  return num;
};

export {
  convertTextToTime,
  checkTimeDifference,
  getTimeFromStringIn24hours,
  getTimeFromStringInAmPm,
  capitalize,
  addTimeStrings,
};
